import * as Sentry from '@sentry/react';

export function setTags(userData: any) {
  const { storeId = '' } = userData;

  Sentry.setTag('store', storeId);
}

function stripQuery(value: string): string {
  const [valueWithoutQuery] = value.split('?');

  return valueWithoutQuery;
}

export function scrubSentryEvent(event: Sentry.Event): Sentry.Event {
  const scrubbedEvent = { ...event };

  if (scrubbedEvent.user) {
    // Sentry's User type declares ip_address as string | undefined, but the SDK
    // treats an explicit null as "never fill this in server-side" (unlike an
    // absent field, which the project's IP-storage setting can still back-fill).
    const scrubbedUser: Sentry.User = {};
    Object.assign(scrubbedUser, { ip_address: null });
    scrubbedEvent.user = scrubbedUser;
  }

  if (scrubbedEvent.request) {
    const {
      data, cookies, headers, query_string: requestQueryString, ...restRequest
    } = scrubbedEvent.request;
    const scrubbedRequest = { ...restRequest };

    if (typeof scrubbedRequest.url === 'string') {
      scrubbedRequest.url = stripQuery(scrubbedRequest.url);
    }

    scrubbedEvent.request = scrubbedRequest;
  }

  return scrubbedEvent;
}

export function scrubSentryBreadcrumb(breadcrumb: Sentry.Breadcrumb): Sentry.Breadcrumb {
  const scrubbedBreadcrumb = { ...breadcrumb };

  if (scrubbedBreadcrumb.data) {
    const scrubbedData = { ...scrubbedBreadcrumb.data };

    if (typeof scrubbedData.url === 'string') {
      scrubbedData.url = stripQuery(scrubbedData.url);
    }

    if (typeof scrubbedData.from === 'string') {
      scrubbedData.from = stripQuery(scrubbedData.from);
    }

    if (typeof scrubbedData.to === 'string') {
      scrubbedData.to = stripQuery(scrubbedData.to);
    }

    scrubbedBreadcrumb.data = scrubbedData;
  }

  return scrubbedBreadcrumb;
}
